import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { UnsafeAny } from '@ts/General';

import t from '@localise/translate';

const containerStyle = {
  width: '100%',
  height: '500px',
};

const darkMapStyle = [
  { elementType: 'geometry', stylers: [{ color: '#212121' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#212121' }] },
  { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#757575' }] },
  { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#181818' }] },
  { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#2c2c2c' }] },
  { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#8a8a8a' }] },
  { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#2f3948' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#000000' }] },
];

const options = {
  styles: darkMapStyle,
  disableDefaultUI: true,
  zoomControl: true,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
};

const companyName = 'ROVI SPORT';

const customIcon = {
  url: `data:image/svg+xml;utf-8,
  <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 24 24' fill='rgba(0, 216, 143, 0.80)'>
    <path d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 
    9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z'/>
  </svg>`,
  scaledSize: { width: 36, height: 36 },
  anchor: { x: 18, y: 36 },
  labelOrigin: { x: 18, y: -10 },
} as UnsafeAny; // Reset type to not wait for google maps to load

export const DarkMap = () => {
  const coordinates = t('client.coordinates');

  return (
    <LoadScript googleMapsApiKey="AIzaSyAH4Bp00qAayYvFhLVjw6huPsxbZ9P5kUY">
      <GoogleMap mapContainerStyle={containerStyle} center={coordinates} zoom={17} options={options}>
        <Marker
          position={coordinates}
          icon={customIcon}
          label={{
            text: companyName,
            color: '#00d88fcc',
            fontSize: '14px',
            fontWeight: 'bold',
          }}
        />
      </GoogleMap>
    </LoadScript>
  );
};
